import type { ReactElement, ReactNode } from 'react';
import { cn } from '../util/classes.ts';

export type ToolbarProps = {
    children?: ReactNode;
    className?: string;
};

export function Toolbar({ children, className }: ToolbarProps): ReactElement {
    return (
        <div
            className={cn(
                'flex flex-row gap-default l2l3:gap-cozy',
                'l2l3:*:data-join-children:pr-cozy',
                'l2l3:*:data-join-children:border-r l2l3:*:data-join-children:border-r-line-weak',
                className,
            )}
        >
            {children}
        </div>
    );
}
